export default __webpack_public_path__ + "static/media/cardNextBtn.b37842f3.svg";